var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    name: 'orangeLoanCreditStatus',
    data: function () {
        return {
            status: 0,
        };
    },
    computed: __assign({}, mapState('info', {
        merchantOperationInfo: 'merchantOperationInfo',
    })),
    created: function () {
        this.status = Number(this.$route.query.status);
        this.$emit('get-credit-status', {
            creditStatus: 3,
            stepStatus: 1,
        });
    },
    methods: {
        returnApply: function () {
            this.$router.push({ name: 'orangeLoanHome', query: { query: true } });
        },
    },
});
